$(document).ready(function() {
   
   // $('.match').matchHeight();
  
    ScrollReveal().reveal('.tekstipalsta .teksti', {
        duration: 500,
        delay: 375,
        distance: '250%',
        origin: 'bottom',
    });

    //KARUSELLIFIX
    //$('.carousel-item:first').addClass('active');

    //ONCLICK
    /*
    $("#hyvjohtaja").on("click", function() { 
        $('.kaikki').addClass("hidden");
        $('.kaikki.hyvjohtaja').removeClass("hidden");
        $('.linkit .button').removeClass("active");
        $(this).addClass("active");
    });
    */

    //NAVIFIX
    window.addEventListener('click', function(e){
        if (document.getElementById('navbarNavOffcanvas').contains(e.target)) {
            $('.navbar-toggler').addClass('activee'); 
        } 
        else if (document.getElementById('heremeout').contains(e.target))  {
            $('.navbar-toggler').toggleClass('activee'); 
        }
        else {
            $('.navbar-toggler').removeClass('activee'); 
        }
    });

    //EKASANA BOLDILLA
    $('.solu .nimi').each(function(){
        var me = $(this)
        , t = me.text().split(' ');
        me.html( '<strong>'+t.shift()+'</strong> '+t.join(' ') );
    });

});